import api from './client'
import { invalidateCache, clearAllCache } from '../../utils/cache'

export const login = (data) => {
  clearAllCache()
  return api.post('/auth/login', data).then((res) => res.data)
}

export const register = (data) => {
  clearAllCache()
  return api.post('/auth/register', data).then((res) => res.data)
}

export const logout = () => {
  clearAllCache()
  return api.post('/auth/logout').then((res) => res.data)
}

export const getMe = (forceRefresh = false, requestConfig = {}) => {
  if (forceRefresh) invalidateCache('/auth/me')
  return api.get('/auth/me', { useCache: !forceRefresh, ...requestConfig }).then((res) => res.data)
}

export const verifyEmail = (code) => api.post('/auth/verify-email', { code }).then((res) => res.data)
export const resendVerification = () => api.post('/auth/resend-verification').then((res) => res.data)
export const confirmRegistration = (email, code) =>
  api.post('/auth/confirm-registration', { email, code }).then((res) => res.data)
export const resendRegistrationCode = (email) =>
  api.post('/auth/resend-registration-code', { email }).then((res) => res.data)
export const forgotPassword = (email) =>
  api.post('/auth/forgot-password', { email }).then((res) => res.data)
export const resetPassword = (data) =>
  api.post('/auth/reset-password', data).then((res) => res.data)
export const resendResetCode = (email) =>
  api.post('/auth/resend-reset-code', { email }).then((res) => res.data)
export const closeAccount = () => api.delete('/auth/account').then((res) => res.data)

export const getProfile = (forceRefresh = false) => {
  if (forceRefresh) invalidateCache('/auth/profile')
  return api.get('/auth/profile', { useCache: !forceRefresh }).then((res) => res.data)
}

export const updateProfile = (data) => {
  invalidateCache('/auth/profile')
  invalidateCache('/auth/me')
  return api.put('/auth/profile', data).then((res) => res.data)
}

export const changePassword = (data) => api.put('/auth/password', data).then((res) => res.data)
export const getUserStats = () => api.get('/auth/stats').then((res) => res.data)

export const listUsers = (includeInactive = false) => {
  const params = includeInactive ? '?include_inactive=true' : ''
  return api.get(`/admin/users${params}`).then((res) => res.data)
}
export const getUser = (userId) => api.get(`/admin/users/${userId}`).then((res) => res.data)
export const updateUser = (userId, data) =>
  api.put(`/admin/users/${userId}`, data).then((res) => res.data)
export const toggleUserStatus = (userId, isActive) =>
  api.post(`/admin/users/${userId}/activate`, { is_active: isActive }).then((res) => res.data)
